
import React from 'react';
import Sketch from 'react-p5';
import { useThemeStore } from '@/stores/themeStore';

export const ParticleBackground: React.FC = () => {
  const theme = useThemeStore((state) => state.theme);

  const particles: Particle[] = [];
  
  const getParticleCount = () => {
    const width = window.innerWidth;
    if (width < 768) {
      return 25;
    }
    if (width < 1024) {
      return 40;
    }
    return 70;
  };

  const particleCount = getParticleCount();
  const connectDistance = 120;

  class Particle {
    p5: any;
    x: number;
    y: number;
    size: number;
    speedX: number;
    speedY: number;
    color: any;

    constructor(p5: any) {
      this.p5 = p5;
      this.x = p5.random(p5.width);
      this.y = p5.random(p5.height);
      this.size = p5.random(1, 4);
      this.speedX = p5.random(-0.5, 0.5);
      this.speedY = p5.random(-0.5, 0.5);
      
      if (theme === 'dark') {
        this.color = p5.color(100, 180, 255, p5.random(100, 200));
      } else {
        this.color = p5.color(0, 120, 220, p5.random(100, 200));
      }
    }

    update() {
      this.x += this.speedX;
      this.y += this.speedY;

      if (this.x < 0) this.x = this.p5.width;
      if (this.x > this.p5.width) this.x = 0;
      if (this.y < 0) this.y = this.p5.height;
      if (this.y > this.p5.height) this.y = 0;
    }

    display() {
      this.p5.noStroke();
      this.p5.fill(this.color);
      this.p5.circle(this.x, this.y, this.size);
    }
  }

  const setup = (p5: any, canvasParentRef: Element) => {
    p5.createCanvas(p5.windowWidth, p5.windowHeight).parent(canvasParentRef);
    particles.length = 0; 
    for (let i = 0; i < particleCount; i++) {
      particles.push(new Particle(p5));
    }
  };

  const draw = (p5: any) => {
    if (theme === 'dark') {
      p5.background(18, 18, 18, 25);
    } else {
      p5.background(244, 247, 246, 40);
    }

    for (let i = 0; i < particles.length; i++) {
      const p1 = particles[i];
      if (!p1) continue;

      p1.update();
      p1.display();

      for (let j = i + 1; j < particles.length; j++) {
        const p2 = particles[j];
        if (!p2) continue;

        const distance = p5.dist(p1.x, p1.y, p2.x, p2.y);

        if (distance < connectDistance) {
          const alpha = p5.map(distance, 0, connectDistance, 150, 0);
          const lineColor = p1.color;
          lineColor.setAlpha(alpha);

          p5.stroke(lineColor);
          p5.strokeWeight(0.5);
          p5.line(p1.x, p1.y, p2.x, p2.y);
        }
      }
    }
  };

  const windowResized = (p5: any) => {
    p5.resizeCanvas(p5.windowWidth, p5.windowHeight);
    const newParticleCount = getParticleCount();
    particles.length = 0;
    for (let i = 0; i < newParticleCount; i++) {
      particles.push(new Particle(p5));
    }
  };

  return (
    <div className="particle-background">
      <Sketch key={theme} setup={setup} draw={draw} windowResized={windowResized} />
    </div>
  );
};